export {
  renderHtmlStream as INTERNAL_renderHtmlStream,
  renderHtmlFallback as INTERNAL_renderHtmlFallback,
} from '../vite-rsc/ssr.js';
